export default "<re-captcha (resolved)=\"OnCaptchaResolved($event)\" [siteKey]=\"SiteKey\"></re-captcha>";